import { CustomPopupSniffer } from '@/components/popup-logic/sniffers/custom';
import { PopupMonitor } from '../components/popup-logic';
import { KlaviyoSniffer } from '../components/popup-logic/sniffers/klaviyo';

// import globalPopup from '@/components/popup-logic/definitions/global-popup';
import signUpForms from '@/components/popup-logic/definitions/sign-up-forms';
import signUpFormsMedispa from '@/components/popup-logic/definitions/sign-up-forms-medispa';
import needHelpPopup from '@/components/popup-logic/definitions/need-help-popup';
import { PopupTimer } from '@/components/popup-logic/timer';
import { createLogger } from '@/lib/logger';

function setupCustomForms() {
  // globalPopup();
  signUpForms();
  signUpFormsMedispa();
  needHelpPopup();
}

document.addEventListener('DOMContentLoaded', function () {
  const log = createLogger('popup-logic');
  // Initialize the popup monitor with global callbacks
  const popupMonitor = new PopupMonitor({
    onOpen: (popup) => {
      log.info(`Global: Popup ${popup.getDisplayName()} opened`);
    },
    onClose: (popup) => {
      log.info(`Global: Popup ${popup.getDisplayName()} closed`);

      // Ensure we always get the full interval delay between popup views
      window.popupTimer.reset();
    },
  });

  window.popupMonitor = popupMonitor;

  window.klaviyoSniffer = new KlaviyoSniffer();

  window.klaviyoSniffer.sniff();

  window.customSniffer = new CustomPopupSniffer();

  window.customSniffer.sniff();

  window.popupTimer = new PopupTimer({
    triggerThreshold: 15000,
    callback: async () => {
      if (!popupMonitor.canShowPopup()) return;

      const popup = popupMonitor.getNextPopup();

      if (!popup) {
        return;
      }

      if (popup) {
        log.debug(`Showing popup ${popup.getDisplayName()}`);
        const showPopupResult = await popupMonitor.showPopup(popup.getId());
        if (!showPopupResult) {
          log.debug('Failed to show popup');

          // Remove this popup from our list
          popupMonitor.removePopup(popup.getId());
        }
      }
    },
  });

  // Install our custom forms
  setupCustomForms();

  // Wait 5 seconds, then show the first popup in our list
  setTimeout(async () => {
    const popup = popupMonitor.getNextPopup();
    if (popup) {
      log.debug(`Showing popup ${popup.getId()}`);
      const showPopupResult = await popupMonitor.showPopup(popup.getId());
      if (!showPopupResult) {
        log.debug('Failed to show popup');

        // Remove this popup from the list
        popupMonitor.removePopup(popup.getId());
      }
    }
  }, 5000);

  // Start the timer
  window.popupTimer.start();
});
